import React, { useState, useEffect } from 'react';
import { Film, Tv, Radio, Smartphone, Bell, LogOut, Menu, X, ImageIcon, BarChart2, DollarSign } from 'lucide-react';
import { FeedPublisher } from '../../components/publishers/FeedPublisher';
import { MoviePublisher } from '../../components/publishers/MoviePublisher';
import { EpisodePublisher } from '../../components/publishers/EpisodePublisher';
import { ShortsPublisher } from '../../components/publishers/ShortsPublisher';
import { AlertPublisher } from '../../components/publishers/AlertPublisher';
import VisitasContent from '../../components/publishers/VisitasContent';


export default function AdminPanelMobile({ onLogout }: { onLogout: () => void }) {
  const [activeTab, setActiveTab] = useState<'movies' | 'episodes' | 'feed' | 'shorts' | 'alerts' | 'visits' | 'ads'>('movies');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [liveTitle, setLiveTitle] = useState('');
  const [liveThumb, setLiveThumb] = useState('');

  // Captura em tempo real do que é digitado nos inputs do formulário filho
  useEffect(() => {
    const handleTyping = () => {
      const inputs = document.querySelectorAll('input');
      inputs.forEach(input => {
        const placeholder = (input.placeholder || '').toLowerCase();
        const val = input.value || '';

        if (placeholder.includes('título') || placeholder.includes('titulo') || placeholder.includes('assunto') || placeholder.includes('obras')) {
          if (val) setLiveTitle(val);
        }

        if (placeholder.includes('capa') || placeholder.includes('imagem') || placeholder.includes('url') || placeholder.includes('trailer') || placeholder.includes('vídeo') || placeholder.includes('video')) {
          if (val.startsWith('http')) setLiveThumb(val);
        }
      });
    };

    window.addEventListener('input', handleTyping);
    return () => window.removeEventListener('input', handleTyping);
  }, [activeTab]);

  const handleTabChange = (tab: 'movies' | 'episodes' | 'feed' | 'shorts' | 'alerts' | 'visits' | 'ads') => {
    setActiveTab(tab);
    setLiveTitle('');
    setLiveThumb('');
    setIsMenuOpen(false); // Fecha o menu hambúrguer ao selecionar
  };

  const isShort = activeTab === 'shorts';

  const menuItems = [
    { id: 'movies', label: 'Filmes', icon: <Film size={16} /> },
    { id: 'episodes', label: 'Episódios', icon: <Tv size={16} /> },
    { id: 'feed', label: 'Feed', icon: <Radio size={16} /> },
    { id: 'shorts', label: 'Shorts', icon: <Smartphone size={16} /> },
    { id: 'alerts', label: 'Gerenciar Avisos', icon: <Bell size={16} /> },
    { id: 'visits', label: 'Visitas', icon: <BarChart2 size={16} /> },
    { id: 'ads', label: 'Anúncios', icon: <DollarSign size={16} /> }, // 👈 Novo item no menu mobile
  ];

  return (
    <div style={{ backgroundColor: '#0A0A0A', color: '#fff', minHeight: '100vh', fontFamily: 'system-ui, sans-serif', paddingBottom: '80px', boxSizing: 'border-box', overflowX: 'hidden' }}>
      
      {/* Topo do Celular com Menu Hambúrguer */}
      <div style={{ backgroundColor: '#111', borderBottom: '1px solid #222', padding: '10px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button 
            onClick={() => setIsMenuOpen(true)}
            style={{ backgroundColor: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center' }}
          >
            <Menu size={22} />
          </button>
          <h2 style={{ fontSize: '13px', fontWeight: '900', margin: 0 }}>
            DOIS<span style={{ color: '#E50914' }}>PLAY</span> <span style={{ fontSize: '9px', color: '#888' }}>ADMIN</span>
          </h2>
        </div>
        
        <button 
          onClick={onLogout}
          style={{
            backgroundColor: 'rgba(255,77,77,0.1)', color: '#ff4d4d', border: '1px solid rgba(255,77,77,0.3)',
            padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontWeight: '600', fontSize: '11px',
            display: 'flex', alignItems: 'center', gap: '4px'
          }}>
          <LogOut size={12} /> Sair
        </button>
      </div>

      {/* GAVETA DO MENU HAMBÚRGUER (Sidebar deslizante) */}
      {isMenuOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1000, display: 'flex' }}>
          <div 
            onClick={() => setIsMenuOpen(false)}
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.7)' }}
          />

          <div style={{ position: 'relative', width: '250px', backgroundColor: '#141414', height: '100%', borderRight: '1px solid #333', display: 'flex', flexDirection: 'column', padding: '20px 0', boxSizing: 'border-box', zIndex: 1001 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 16px 15px 16px', borderBottom: '1px solid #222' }}>
              <h3 style={{ fontSize: '14px', fontWeight: 'bold', margin: 0, color: '#fff' }}>Menu do Painel</h3>
              <button onClick={() => setIsMenuOpen(false)} style={{ background: 'none', border: 'none', color: '#aaa', cursor: 'pointer' }}>
                <X size={20} />
              </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '15px 10px', flex: 1, overflowY: 'auto' }}>
              {menuItems.map(item => (
                <button
                  key={item.id}
                  onClick={() => handleTabChange(item.id as any)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '10px', width: '100%', padding: '12px',
                    backgroundColor: activeTab === item.id ? '#E50914' : 'transparent',
                    color: activeTab === item.id ? '#fff' : '#aaa',
                    border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', textAlign: 'left'
                  }}
                >
                  {item.icon} {item.label}
                </button>
              ))}
            </div>

            <div style={{ padding: '0 10px' }}>
              <button 
                onClick={onLogout}
                style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '10px 12px', backgroundColor: 'rgba(255,77,77,0.1)', color: '#ff4d4d', border: '1px solid rgba(255,77,77,0.3)', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px' }}>
                <LogOut size={14} /> Sair da Conta
              </button>
            </div>
          </div>
        </div>
      )}

      {/* PRÉVIA REAL COM TÍTULO E CAPA NO TOPO (Apenas para abas de vídeo) */}
      {activeTab !== 'alerts' && activeTab !== 'visits' && activeTab !== 'ads' && (
        <div style={{ backgroundColor: '#141414', borderBottom: '1px solid #222', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '15px' }}>
          <div style={{
            width: isShort ? '60px' : '75px',
            height: isShort ? '106px' : '100px',
            backgroundColor: '#000', borderRadius: '6px', border: '1px solid #444',
            overflow: 'hidden', position: 'relative', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 10px rgba(0,0,0,0.6)'
          }}>
            {liveThumb ? (
              <img src={liveThumb} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              <ImageIcon color="#555" size={24} />
            )}
          </div>
          
          <div style={{ flex: 1, minWidth: 0 }}>
            <span style={{ fontSize: '9px', color: '#E50914', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              👁️ Prévia ao Vivo ({activeTab})
            </span>
            <p style={{ fontSize: '13px', color: '#fff', fontWeight: 'bold', margin: '6px 0 4px 0', wordBreak: 'break-word', lineHeight: '1.2' }}>
              {liveTitle || 'Digite o título nos campos abaixo...'}
            </p>
            <span style={{ fontSize: '9px', color: '#888', display: 'block' }}>
              O título e a capa aparecem aqui instantaneamente.
            </span>
          </div>
        </div>
      )}

      {/* CONTEÚDO DO FORMULÁRIO */}
      <div style={{ padding: '12px', width: '100%', boxSizing: 'border-box' }}>
        <div style={{ width: '100%', maxWidth: '100%', margin: 0 }}>
          {activeTab === 'movies' && <MoviePublisher />}
          {activeTab === 'episodes' && <EpisodePublisher />}
          {activeTab === 'feed' && <FeedPublisher />}
          {activeTab === 'shorts' && <ShortsPublisher />}
          {activeTab === 'alerts' && <AlertPublisher />}
          {activeTab === 'visits' && <VisitasContent />}
          
        </div>
      </div>

    </div>
  );
}